import { useCreateClientModal } from "./useCreateClientModal";
import styles from "./CreateClientModal.module.css";

function Modal({ closeModal }) {
  const {
    code,
    name,
    cnpj,
    email,
    phone,
    handleCode,
    handleName,
    handleCnpj,
    handleEmail,
    handlePhone,
    onSaveClick,
    isFormValid
  } = useCreateClientModal(closeModal);
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>
            <label>
              <span>Código do Cliente</span>
              <input
                type="text"
                placeholder="Digite seu código"
                value={code}
                onChange={handleCode}
              />
            </label>

            <label>
              <span>Nome do Cliente</span>
              <input
                type="text"
                placeholder="Digite seu nome"
                value={name}
                onChange={handleName}
              />
            </label>

            <label>
              <span>CNPJ</span>
              <input
                type="text"
                placeholder="Digite seu CNPJ"
                value={cnpj}
                onChange={handleCnpj}
              />
            </label>

            <label>
              <span>Email</span>
              <input
                type="email"
                placeholder="Digite seu email"
                value={email}
                onChange={handleEmail}
              />
            </label>

            <label>
              <span>Telefone</span>
              <input
                type="text"
                placeholder="Digite seu telefone"
                value={phone}
                onChange={handlePhone}
              />
            </label>

          </form>
        </div>

        <div className={styles.buttonContent}>
          <button
            onClick={onSaveClick}
            className={styles.buttonConfirm}
            disabled={!isFormValid}>
            Salvar Cliente
          </button>

          <button
            onClick={closeModal}
            className={styles.buttonCancel}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;